import script from "./CockpitFrame.vue?vue&type=script&setup=true&lang=js"
export * from "./CockpitFrame.vue?vue&type=script&setup=true&lang=js"

import "./CockpitFrame.vue?vue&type=style&index=0&id=aa4fca52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa4fca52"]])

export default __exports__